import { section } from "@/neon";

section("rich-text", {
  onLoad() {},
  onUnload() {},
});
